const yellow = '#ffc044';
const blue = '#060c6b';
const blue2 = '#0a13aa';
const blue3 = '#0c137a';
const lightBlue = '#747cf9';
const lightBlue2 = '#91B7FE';
const lightGrey = '#cecece';
const grey = '#999';
const mediumGrey = '#666';
const darkGrey = '#333';
const transparentGrey = "#cecece40";
const transparentGrey2 = "#cecece70";
const transparentGrey3 = "rgba(0, 0, 0, 0.5)";
const transparentGrey4 = "rgba(0, 0, 0, 0.75)";
const transparentBlue = "#0a13aaBF";
const invalid = '#B22222';
const invalidTransparent = 'rgba(178, 34, 34, 0.8)';
const red = '#e50209';
const green = '#2ECC71';
const neonGreen = '#7cfc00';
const white = '#FFFFFF';
const black = '#000000';
const yellowBrown = '#C89400';
const google = '#4285F4';
const facebook = '#3b5998';

export default {
  yellow,
  blue,
  blue2,
  blue3,
  lightBlue,
  lightBlue2,
  lightGrey,
  grey,
  mediumGrey,
  darkGrey,
  transparentGrey,
  transparentGrey2,
  transparentGrey3,
  transparentGrey4,
  transparentBlue,
  // lightText: lightGrey,
  lightText: "#efefef",
  greyText: grey,
  mediumText: mediumGrey,
  darkText: darkGrey,
  highlightText: yellow,
  neonGreenText: neonGreen,
  textInputBackground: '#29319C',
  invalid,
  invalidTransparent,
  red,
  green,
  neonGreen,
  white,
  black,
  yellowBrown,
  google,
  facebook,
};
